import * as type from './types'
import { shipmentService, providerService, shipmentGroupByDayService } from '@/_services'
import i18n from '@/i18n'

const actions = {
  setSelectedShipment({ commit, dispatch }, { shipmentID, shipment }) {
    commit(type.REMOVE_SHIPMENTS_CONTEXT_ERRORS)
    commit(type.REMOVE_SELECTED_SHIPMENT)
    commit(type.REMOVE_PROVIDERS_MENU_FILTER)
    dispatch('setShipmentsResetState', {}, { root: true })
    commit(type.SET_IS_SELECTING_SHIPMENT, { flag: true })
    commit(type.SET_SELECTED_SHIPMENT, { shipment })
    shipmentService.getShipmentForContext({ shipmentID })
    .then((shipment) => {
      commit(type.SET_SELECTED_SHIPMENT, { shipment })
    })
    .catch((error) => {
      commit(type.SET_SHIPMENTS_CONTEXT_ERRORS, { error })
    })
    .finally(() => (commit(type.SET_IS_SELECTING_SHIPMENT, { flag: false })))
  },
  removeSelectedShipment({ commit }) {
    commit(type.REMOVE_SELECTED_SHIPMENT)
  },
  setListPossibleProviders({ commit }, { shipmentID }) {
    commit(type.REMOVE_SHIPMENTS_CONTEXT_ERRORS)
    commit(type.SET_IS_LOADING_PROVIDERS, { flag: true })
    providerService.listPossibleProviders({ shipmentID })
    .then((providers) => {
      commit(type.SET_POSSIBLE_PROVIDERS, { providers })
    })
    .catch((error) => {
      commit(type.SET_SHIPMENTS_CONTEXT_ERRORS, { error })
    })
    .finally(() => (commit(type.SET_IS_LOADING_PROVIDERS, { flag: false })))
  },
  setSelectedProvider({ commit, dispatch }, { shipmentID, providerID, providerType }) {
    commit(type.REMOVE_SHIPMENTS_CONTEXT_ERRORS)
    commit(type.SET_IS_SETTING_PROVIDER, { flag: true })
    providerService.setProvider({ shipmentID, providerID, providerType })
    .then((response) => {
      let shipment = response
      dispatch('showSnackbar', { message: i18n.t('snackbars.set_provider_success'), color: 'success' }, { root: true })

      // When removing provider set price to 0, so to be able to update price correctly when we change provider without reloading the page
      if (providerID === null && providerType === null) {
        shipment = { ...shipment, pricing: { price: 0, currency: 'EUR' } }
      }

      commit(type.UPDATE_SELECTED_SHIPMENT, { shipment })
      dispatch('shipmentsGroupByDay/updateSelectedShipmentCard', { shipment }, { root: true })
    })
    .catch((error) => {
      console.error(error)
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
      commit(type.SET_SHIPMENTS_CONTEXT_ERRORS, { error })
    })
    .finally(() => (commit(type.SET_IS_SETTING_PROVIDER, { flag: false })))
  },
  setSelectedProviderFromQuotes({ commit, dispatch }, { shipmentID, providerID, providerType }) {
    commit(type.REMOVE_SHIPMENTS_CONTEXT_ERRORS)
    commit(type.SET_IS_SETTING_PROVIDER, { flag: true })
    providerService.setProvider({ shipmentID, providerID, providerType })
    .then((shipment) => {
      commit(type.UPDATE_SELECTED_SHIPMENT, { shipment })
    })
    .catch((error) => {
      console.error(error)
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
      commit(type.SET_SHIPMENTS_CONTEXT_ERRORS, { error })
    })
    .finally(() => (commit(type.SET_IS_SETTING_PROVIDER, { flag: false })))
  },
  setProviderMenuFilter({ commit }, { attribute }) {
    commit(type.SET_PROVIDERS_MENU_FILTER, { attribute })
  },
  removeProviderMenuFilter({ commit }, { attribute }) {
    commit(type.REMOVE_PROVIDERS_MENU_FILTER, { attribute })
  },
  setShipmentLabels({ commit, dispatch }, { shipment, labels }) {
    commit(type.SET_SHIPMENTS_LABELS, { labels })
    dispatch('shipmentsGroupByDay/updateSelectedShipmentCardLabels', { shipment, labels }, { root: true })
    shipmentService.updateShipmentLabels({ shipmentID: shipment.id, labels }).then(() => {
      dispatch('showSnackbar', { message: i18n.t('snackbars.shipment_labels_updated'), color: 'success' }, { root: true })
    }).catch((error) => {
      console.error(error)
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
    })
  },
  setResetState({ commit }) {
    commit(type.SET_RESET_STATE)
  },
  handleSetGoodsValueByDay ({commit, dispatch}, {id, value}) {
    // console.log(id, value)
    commit(type.REMOVE_GOODS_VALUE_ERROR)
    commit(type.SET_GOODS_VALUE_BY_DAY_FETCHING, { isFetching: true })
    shipmentService.setGoodsValue({ id, value }).then(() => {
      commit(type.GOODS_VALUE_BY_DAY_UPDATED, {id, value})
      dispatch('showSnackbar', { message: i18n.t('snackbars.goods_value_updated'), color: 'success' }, { root: true })
    }).catch((error) => {
      console.error(error)
      commit(type.SET_GOODS_VALUE_ERROR, { errors: error })
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
    }).finally(() => {
      commit(type.SET_GOODS_VALUE_BY_DAY_FETCHING, { isFetching: false })
    })
  },
  setCustomProvider ({ commit, dispatch }, { shipmentID, providerName, transportMode, price, currency }) {
    commit(type.REMOVE_SHIPMENTS_CONTEXT_ERRORS)
    commit(type.SET_IS_SETTING_CUSTOM_PROVIDER, { flag: true })
    providerService.setCustomProvider({ shipmentID, name: providerName, type: transportMode, price: { price, currency } })
    .then((shipment) => {
      dispatch('showSnackbar', { message: i18n.t('snackbars.set_provider_success'), color: 'success' }, { root: true })
      commit(type.UPDATE_SELECTED_SHIPMENT, { shipment })
      dispatch('shipmentsGroupByDay/updateSelectedShipmentCard', { shipment }, { root: true })
    })
    .catch((error) => {
      console.error(error)
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
      commit(type.SET_SHIPMENTS_CONTEXT_ERRORS, { error })
    })
    .finally(() => (commit(type.SET_IS_SETTING_CUSTOM_PROVIDER, { flag: false })))
  }
}
export default actions
